import React, { useCallback, useMemo } from "react";
import * as Scrivito from "scrivito";
import { useProductConfiguratorStore } from "components/_ProductConfigurator/store/ProductConfiguratorStore";
import { ProductConfiguratorResultMainView } from "components/_ProductConfigurator/SubComponents/ProductConfigurationResult/ProductResultMainView/ProductConfiguratorResultMainView";
import { ProductConfiguratorResultSecondaryView } from "components/_ProductConfigurator/SubComponents/ProductConfigurationResult/ProductConfiguratorResultSecondaryView";

export const ProductConfiguratorResult = Scrivito.connect(
  ({ isModalView, hasInputsAndNotModal }) => {
    const { product } = useProductConfiguratorStore.use.productData() || {};
    const { changeProduct } = useProductConfiguratorStore.use.actions();

    const strategyOptions = useMemo(
      () =>
        product?.availableStrategies?.map((strat) => ({
          value: strat.id,
          label: strat.presentation,
        })),
      [product?.availableStrategies],
    );

    const selectedOption = useMemo(
      () =>
        strategyOptions?.find(
          (opt) => opt.value === product?.currentStrategyId,
        ),
      [product?.currentStrategyId, strategyOptions],
    );

    const handleSelectStrategy = useCallback(
      (e) => {
        changeProduct({
          newStrategyId: e.value,
        });
      },
      [changeProduct],
    );

    return (
      <>
        {hasInputsAndNotModal ? (
          <ProductConfiguratorResultMainView
            strategyOptions={strategyOptions}
            selectedOption={selectedOption}
            handleSelectStrategy={handleSelectStrategy}
          />
        ) : (
          <ProductConfiguratorResultSecondaryView
            isModalView={isModalView}
            strategyOptions={strategyOptions}
            selectedOption={selectedOption}
            handleSelectStrategy={handleSelectStrategy}
          />
        )}
      </>
    );
  },
);
